// Frontend configuration for ZK Bridge
// This file handles environment variables and configuration for the React app

const config = {
  // Bridge API endpoints
  bridgeApi: {
    endpoints: {
      health: '/health',
      bridgeStatus: '/api/bridge-status',
      userBridges: '/api/user-bridges',
      bridgeRequests: '/api/bridge-requests',
      bridgeStats: '/api/bridge-stats',
      feeStats: '/api/fee-stats',
      networkStats: '/api/network-stats'
    }
  },
  
  // Bridge status polling configuration
  statusPolling: {
    enabled: process.env.REACT_APP_STATUS_POLLING_ENABLED === 'true',
    interval: parseInt(process.env.REACT_APP_STATUS_POLLING_INTERVAL || '2000'),
    maxRetries: parseInt(process.env.REACT_APP_STATUS_POLLING_MAX_RETRIES || '20'),
    retryDelays: [
      2000,   // 2s
      4000,   // 4s  
      8000,   // 8s
      15000,  // 15s
      30000,  // 30s
      60000,  // 1m
      120000, // 2m
      300000, // 5m
      600000, // 10m
      900000, // 15m
      1200000, // 20m
      1800000, // 30m
      2400000, // 40m
      3000000, // 50m
      3600000, // 1h
      4200000, // 1h 10m
      4800000, // 1h 20m
      5400000, // 1h 30m
      6000000, // 1h 40m
      6600000  // 1h 50m
    ], // Extended exponential backoff delays for longer processing times
    initialDelay: 0, // No delay: Start status polling immediately
    maxTotalTime: parseInt(process.env.REACT_APP_STATUS_POLLING_MAX_TOTAL_TIME || '7200000')
  }
};

export default config;
